import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-white" data-id="element-15">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-17">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-dark mb-4" data-id="element-18">
            Get in Touch
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-19">
            Ready to start your next remodeling project? Contact us today for a
            consultation.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-20">
          {/* Email Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-brand-light p-10 flex flex-col items-center text-center border border-gray-100" data-id="element-21">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 text-brand-accent shadow-sm" data-id="element-22">
              <Mail size={28} strokeWidth={1.5} data-id="element-23" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-2" data-id="element-24">
              Email Us
            </h3>
            <p className="text-gray-600 mb-8 font-medium" data-id="element-25">
              ModernFix@protonmail.com
            </p>
            <a href="mailto:ModernFix@protonmail.com" className="px-8 py-3 bg-brand-dark text-white font-medium hover:bg-brand-accent transition-colors duration-300 w-full text-center" data-id="element-26">
              Email Us
            </a>
          </motion.div>

          {/* Phone Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="bg-brand-light p-10 flex flex-col items-center text-center border border-gray-100" data-id="element-27">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 text-brand-accent shadow-sm" data-id="element-28">
              <Phone size={28} strokeWidth={1.5} data-id="element-29" />
            </div>
            <h3 className="text-xl font-serif text-brand-dark mb-2" data-id="element-30">Call Us</h3>
            <p className="text-gray-600 mb-8 font-medium" data-id="element-31">747-477-6633</p>
            <a href="tel:7474776633" className="px-8 py-3 bg-brand-dark text-white font-medium hover:bg-brand-accent transition-colors duration-300 w-full text-center" data-id="element-32">
              Call Us
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}